<template>
   <v-layout aling-start>
      <v-flex>
         <v-snackbar
            v-model="snackbar"
            :color="snackColor"
            :right="true"
            :bottom="true"
            :timeout="4000"
         >
            {{ snackText }}
            <template #action="{ attrs }">
               <v-btn color="white" text v-bind="attrs" @click="snackbar = false">
                  Cerrar
               </v-btn>
            </template>
         </v-snackbar>

         <!-- ================= MODAL: PROGRAMAS DE LA SECCIÓN ================= -->
         <v-dialog v-model="dialogProgramas" max-width="560px" scrollable>
            <v-card>
               <v-card-title class="seccion-cabecera mb-0" style="border-radius: 0">
                  Programas de {{ tipoModal === 'SABATINO' ? 'Sabatinos' : 'Intensivo' }}
               </v-card-title>

               <v-card-text class="pt-4">
                  <div class="caption grey--text text--darken-1 mb-2">
                     Seleccione un programa y agréguelo a esta sección. Los programas
                     agregados se mostrarán cuando la fecha esté vigente.
                  </div>

                  <!-- SELECTOR + AGREGAR -->
                  <div class="d-flex align-center">
                     <v-autocomplete
                        v-model="programaAAgregar"
                        :items="programasParaAgregar"
                        item-text="etiqueta"
                        item-value="programaId"
                        label="Buscar programa"
                        dense
                        outlined
                        hide-details
                        clearable
                        no-data-text="No hay programas disponibles"
                        class="mr-2"
                     />
                     <v-btn
                        color="primary"
                        :disabled="!programaAAgregar"
                        @click="agregarProgramaModal"
                     >
                        <v-icon left small>fas fa-plus</v-icon> Agregar
                     </v-btn>
                  </div>

                  <!-- LISTA DE ASIGNADOS -->
                  <div class="text-subtitle-2 mt-4 mb-1">
                     Programas asignados ({{ seleccionModal.length }})
                  </div>
                  <v-list dense class="asignados-lista">
                     <v-list-item
                        v-for="p in programasSeleccionadosModal"
                        :key="p.programaId"
                     >
                        <v-list-item-content>
                           <v-list-item-title>{{ p.nombre }}</v-list-item-title>
                           <v-list-item-subtitle>
                              {{ p.idioma }} · {{ formatHora(p.inicio) }} -
                              {{ formatHora(p.fin) }}
                           </v-list-item-subtitle>
                        </v-list-item-content>
                        <v-list-item-action>
                           <v-btn
                              icon
                              small
                              color="error"
                              @click="quitarProgramaModal(p.programaId)"
                           >
                              <v-icon small>fas fa-trash</v-icon>
                           </v-btn>
                        </v-list-item-action>
                     </v-list-item>
                     <v-list-item v-if="!seleccionModal.length">
                        <v-list-item-content>
                           <v-list-item-title class="grey--text">
                              Sin programas asignados
                           </v-list-item-title>
                        </v-list-item-content>
                     </v-list-item>
                  </v-list>
               </v-card-text>

               <v-divider></v-divider>
               <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn text @click="dialogProgramas = false">Cancelar</v-btn>
                  <v-btn
                     color="primary"
                     :loading="guardandoProgramas"
                     @click="guardarProgramasModal"
                  >
                     <v-icon left small>fas fa-save</v-icon> Guardar
                  </v-btn>
               </v-card-actions>
            </v-card>
         </v-dialog>

         <v-container fluid>
            <v-layout
               wrap
               :style="
                  $vuetify.breakpoint.xlOnly
                     ? 'padding-right: 8%; padding-left: 8%'
                     : ''
               "
            >
               <!-- TÍTULO -->
               <v-flex xs12 text-center mb-6>
                  <span class="font-weight-medium text-h5">
                     Calendarización de módulos de inglés y francés
                  </span>
               </v-flex>

               <!-- CARGANDO -->
               <v-flex
                  v-if="loading"
                  my-8
                  xs12
                  d-flex
                  justify-center
                  align-center
               >
                  <span
                     class="colorPrimary font-weight-medium mr-2"
                     style="font-size: 24px"
                  >
                     Cargando...
                  </span>
                  <i class="ml-2 fas fa-sync-alt fa-3x fa-spin colorPrimary"></i>
               </v-flex>

               <template v-else>
                  <!-- ================= SABATINOS ================= -->
                  <v-flex xs12 md6 :class="$vuetify.breakpoint.mdAndUp ? 'pr-4' : 'mb-8'">
                     <!-- CABECERA DE SECCIÓN (abre el modal de programas) -->
                     <div
                        class="seccion-cabecera seccion-cabecera--btn"
                        role="button"
                        @click="abrirModalProgramas('SABATINO')"
                     >
                        SABATINOS
                        <v-icon color="white" small class="ml-2">fas fa-cog</v-icon>
                     </div>

                     <!-- CONFIGURACIÓN ADMINISTRATIVA DE FILAS -->
                     <v-card outlined class="pa-3 mb-4">
                        <div class="caption grey--text text--darken-1 mb-2">
                           <v-icon x-small color="primary" class="mr-1">fas fa-calendar-alt</v-icon>
                           Configuración de inscripción (fechas)
                        </div>
                        <v-simple-table dense class="entradas-tabla">
                           <thead>
                              <tr>
                                 <th style="width: 70px">Entrada</th>
                                 <th>Fecha de inicio de inscripción</th>
                                 <th>Fecha fin de inscripción</th>
                                 <th style="width: 48px"></th>
                              </tr>
                           </thead>
                           <tbody>
                              <tr
                                 v-for="(e, i) in entradasSabatinos"
                                 :key="'sab-' + i"
                              >
                                 <td class="text-center font-weight-bold colorPrimary">
                                    {{ i + 1 }}
                                 </td>
                                 <td>
                                    <CustomDatePicker
                                       :date="e.inicio"
                                       label=""
                                       min="2020-01-01"
                                       picker-only
                                       @updateFecha="e.inicio = $event"
                                    />
                                 </td>
                                 <td>
                                    <CustomDatePicker
                                       :date="e.fin"
                                       label=""
                                       :min="e.inicio || '2020-01-01'"
                                       picker-only
                                       @updateFecha="e.fin = $event"
                                    />
                                 </td>
                                 <td class="text-center">
                                    <v-btn
                                       icon
                                       small
                                       color="error"
                                       @click="eliminarEntrada(entradasSabatinos, i)"
                                    >
                                       <v-icon small>fas fa-trash</v-icon>
                                    </v-btn>
                                 </td>
                              </tr>
                              <tr v-if="!entradasSabatinos.length">
                                 <td colspan="4" class="text-center grey--text">
                                    Sin entradas. Agregue una fila.
                                 </td>
                              </tr>
                           </tbody>
                        </v-simple-table>
                        <v-btn
                           small
                           color="primary"
                           text
                           class="mt-2"
                           @click="agregarEntrada(entradasSabatinos)"
                        >
                           <v-icon left small>fas fa-plus</v-icon> Agregar fila
                        </v-btn>
                        <v-btn
                           small
                           color="primary"
                           class="mt-2 ml-2"
                           :loading="guardandoSabatino"
                           @click="guardar('SABATINO')"
                        >
                           <v-icon left small>fas fa-save</v-icon> Guardar
                        </v-btn>
                     </v-card>

                     <!-- ESTADO -->
                     <div class="text-center mb-2">
                        <v-chip :color="estadoSabatinos.color" dark>
                           <v-icon left small>{{ estadoSabatinos.icono }}</v-icon>
                           {{ estadoSabatinos.label }}
                        </v-chip>
                     </div>

                     <!-- ALERTA DE RECARGO -->
                     <v-alert
                        v-if="estadoSabatinos.aplicaRecargo"
                        type="warning"
                        dense
                        text
                        class="mb-2"
                     >
                        Inscripción con Recargo — se aplicará un cargo adicional de
                        <strong>${{ recargoIdiomas.toFixed(2) }}</strong>
                     </v-alert>

                     <!-- PROGRAMAS / CERRADO -->
                     <template v-if="estadoSabatinos.visible">
                        <div class="text-h6 text-center mt-4">
                           Programas de idiomas que aplican:
                        </div>
                        <v-card class="mx-auto font-weight-medium" width="320px" flat>
                           <v-list-item
                              v-for="p in sabatinos"
                              :key="p.programaId"
                              two-line
                           >
                              <v-icon left class="colorPrimary" style="font-size: 10px"
                                 >fas fa-circle</v-icon
                              >
                              <v-list-item-content>
                                 <v-list-item-title>{{ p.nombre }}</v-list-item-title>
                                 <v-list-item-subtitle>
                                    {{ p.idioma }} · {{ formatHora(p.inicio) }} -
                                    {{ formatHora(p.fin) }}
                                 </v-list-item-subtitle>
                              </v-list-item-content>
                           </v-list-item>
                           <v-list-item v-if="!sabatinos.length">
                              <v-list-item-content>
                                 <v-list-item-title class="grey--text">
                                    Sin programas
                                 </v-list-item-title>
                              </v-list-item-content>
                           </v-list-item>
                        </v-card>
                     </template>
                     <v-alert v-else type="info" text dense class="mt-4 text-center">
                        Módulos cerrados temporalmente
                     </v-alert>
                  </v-flex>

                  <!-- DIVISOR -->
                  <v-divider
                     v-if="$vuetify.breakpoint.mdAndUp"
                     vertical
                  ></v-divider>

                  <!-- ================= INTENSIVO ================= -->
                  <v-flex xs12 md6 :class="$vuetify.breakpoint.mdAndUp ? 'pl-4' : ''">
                     <!-- CABECERA DE SECCIÓN (abre el modal de programas) -->
                     <div
                        class="seccion-cabecera seccion-cabecera--btn"
                        role="button"
                        @click="abrirModalProgramas('INTENSIVO')"
                     >
                        INTENSIVO
                        <v-icon color="white" small class="ml-2">fas fa-cog</v-icon>
                     </div>

                     <!-- CONFIGURACIÓN ADMINISTRATIVA DE FILAS -->
                     <v-card outlined class="pa-3 mb-4">
                        <div class="caption grey--text text--darken-1 mb-2">
                           <v-icon x-small color="primary" class="mr-1">fas fa-calendar-alt</v-icon>
                           Configuración de inscripción (fechas)
                        </div>
                        <v-simple-table dense class="entradas-tabla">
                           <thead>
                              <tr>
                                 <th style="width: 70px">Entrada</th>
                                 <th>Fecha de inicio de inscripción</th>
                                 <th>Fecha fin de inscripción</th>
                                 <th style="width: 48px"></th>
                              </tr>
                           </thead>
                           <tbody>
                              <tr
                                 v-for="(e, i) in entradasIntensivo"
                                 :key="'int-' + i"
                              >
                                 <td class="text-center font-weight-bold colorPrimary">
                                    {{ i + 1 }}
                                 </td>
                                 <td>
                                    <CustomDatePicker
                                       :date="e.inicio"
                                       label=""
                                       min="2020-01-01"
                                       picker-only
                                       @updateFecha="e.inicio = $event"
                                    />
                                 </td>
                                 <td>
                                    <CustomDatePicker
                                       :date="e.fin"
                                       label=""
                                       :min="e.inicio || '2020-01-01'"
                                       picker-only
                                       @updateFecha="e.fin = $event"
                                    />
                                 </td>
                                 <td class="text-center">
                                    <v-btn
                                       icon
                                       small
                                       color="error"
                                       @click="eliminarEntrada(entradasIntensivo, i)"
                                    >
                                       <v-icon small>fas fa-trash</v-icon>
                                    </v-btn>
                                 </td>
                              </tr>
                              <tr v-if="!entradasIntensivo.length">
                                 <td colspan="4" class="text-center grey--text">
                                    Sin entradas. Agregue una fila.
                                 </td>
                              </tr>
                           </tbody>
                        </v-simple-table>
                        <v-btn
                           small
                           color="primary"
                           text
                           class="mt-2"
                           @click="agregarEntrada(entradasIntensivo)"
                        >
                           <v-icon left small>fas fa-plus</v-icon> Agregar fila
                        </v-btn>
                        <v-btn
                           small
                           color="primary"
                           class="mt-2 ml-2"
                           :loading="guardandoIntensivo"
                           @click="guardar('INTENSIVO')"
                        >
                           <v-icon left small>fas fa-save</v-icon> Guardar
                        </v-btn>
                     </v-card>

                     <!-- ESTADO -->
                     <div class="text-center mb-2">
                        <v-chip :color="estadoIntensivo.color" dark>
                           <v-icon left small>{{ estadoIntensivo.icono }}</v-icon>
                           {{ estadoIntensivo.label }}
                        </v-chip>
                     </div>

                     <!-- ALERTA DE RECARGO -->
                     <v-alert
                        v-if="estadoIntensivo.aplicaRecargo"
                        type="warning"
                        dense
                        text
                        class="mb-2"
                     >
                        Inscripción con Recargo — se aplicará un cargo adicional de
                        <strong>${{ recargoIdiomas.toFixed(2) }}</strong>
                     </v-alert>

                     <!-- PROGRAMAS / CERRADO -->
                     <template v-if="estadoIntensivo.visible">
                        <div class="text-h6 text-center mt-4">
                           Programas de idiomas que aplican:
                        </div>
                        <v-card class="mx-auto font-weight-medium" width="320px" flat>
                           <v-list-item
                              v-for="p in intensivos"
                              :key="p.programaId"
                              two-line
                           >
                              <v-icon left class="colorPrimary" style="font-size: 10px"
                                 >fas fa-circle</v-icon
                              >
                              <v-list-item-content>
                                 <v-list-item-title>{{ p.nombre }}</v-list-item-title>
                                 <v-list-item-subtitle>
                                    {{ p.idioma }} · {{ formatHora(p.inicio) }} -
                                    {{ formatHora(p.fin) }}
                                 </v-list-item-subtitle>
                              </v-list-item-content>
                           </v-list-item>
                           <v-list-item v-if="!intensivos.length">
                              <v-list-item-content>
                                 <v-list-item-title class="grey--text">
                                    Sin programas
                                 </v-list-item-title>
                              </v-list-item-content>
                           </v-list-item>
                        </v-card>
                     </template>
                     <v-alert v-else type="info" text dense class="mt-4 text-center">
                        Módulos cerrados temporalmente
                     </v-alert>
                  </v-flex>
               </template>
            </v-layout>
         </v-container>
      </v-flex>
   </v-layout>
</template>

<script>
import axios from 'axios'
import { authComputed } from '../helpers'

const CustomDatePicker = () => import('./custom/CustomDatePicker')

export default {
   name: 'CalendarizacionModulos',
   components: {
      CustomDatePicker
   },
   computed: {
      ...authComputed,
      // Solo programas de inglés (2) y francés (6)
      programasIdiomas() {
         return this.programas.filter(
            (p) => p.idiomaId === 2 || p.idiomaId === 6
         )
      },
      // Programas asignados manualmente a cada sección (por ID)
      sabatinos() {
         return this.programasIdiomas.filter((p) =>
            this.programasSabatinoIds.includes(p.programaId)
         )
      },
      intensivos() {
         return this.programasIdiomas.filter((p) =>
            this.programasIntensivoIds.includes(p.programaId)
         )
      },
      // --- Modal de programas ---
      // Programas ya seleccionados en el modal (para listarlos)
      programasSeleccionadosModal() {
         return this.programasIdiomas.filter((p) =>
            this.seleccionModal.includes(p.programaId)
         )
      },
      // Programas que aún se pueden agregar (no seleccionados en el modal)
      programasParaAgregar() {
         return this.programasIdiomas
            .filter((p) => !this.seleccionModal.includes(p.programaId))
            .map((p) => ({
               programaId: p.programaId,
               etiqueta: `${p.nombre} — ${p.idioma}`
            }))
      },
      // Estado automático de cada sección según sus entradas de fechas
      estadoSabatinos() {
         return this.calcularEstadoEntradas(this.entradasSabatinos)
      },
      estadoIntensivo() {
         return this.calcularEstadoEntradas(this.entradasIntensivo)
      }
   },
   data: () => ({
      snackbar: false,
      snackText: '',
      snackColor: 'primary',
      loading: false,
      programas: [],

      // Recargo por pago tardío de módulos de idiomas.
      // Valor encontrado en el backend: Constante.PagoExtraIdiomas = 5 ($5.00).
      recargoIdiomas: 5.0,
      // Días de gracia (prórroga con recargo) posteriores a la Fecha Fin.
      diasGracia: 5,

      // Entradas (períodos) por sección. Cada una: { inicio: 'yyyy-MM-dd', fin: 'yyyy-MM-dd' }
      entradasSabatinos: [{ inicio: '', fin: '' }],
      entradasIntensivo: [{ inicio: '', fin: '' }],
      guardandoSabatino: false,
      guardandoIntensivo: false,

      // Programas asignados a cada sección (IDs), gestionados desde el modal
      programasSabatinoIds: [],
      programasIntensivoIds: [],

      // Estado del modal de programas
      dialogProgramas: false,
      tipoModal: '',
      seleccionModal: [],
      programaAAgregar: null,
      guardandoProgramas: false
   }),
   created() {
      // Validando acceso al componente (permiso 27 del módulo Colecturía Digital)
      if (this.permController(27, 'ver')) {
         this.listarProgramas()
         this.cargarEntradas()
         this.cargarProgramasAsignados()
      } else {
         this.$router.push({ name: 'inicio' })
      }
   },
   methods: {
      listarProgramas() {
         this.loading = true
         axios
            .get('api/ProgramaIdioma?activo=true')
            .then((response) => {
               this.programas = response.data
            })
            .catch(() => {
               this.showSnack('Error al obtener los programas.', 'snackError')
            })
            .finally(() => {
               this.loading = false
            })
      },
      // --- Carga y guardado de entradas ---
      cargarEntradas() {
         axios
            .get('api/CalendarizacionModulos')
            .then((r) => {
               const map = (arr) =>
                  arr && arr.length
                     ? arr.map((e) => ({ inicio: e.fechaInicio, fin: e.fechaFin }))
                     : [{ inicio: '', fin: '' }]
               this.entradasSabatinos = map(r.data.sabatino)
               this.entradasIntensivo = map(r.data.intensivo)
            })
            .catch(() => {
               this.showSnack('Error al cargar la calendarización.', 'snackError')
            })
      },
      guardar(tipo) {
         const arr =
            tipo === 'SABATINO' ? this.entradasSabatinos : this.entradasIntensivo

         // Validación: la fecha fin no puede ser menor que la fecha de inicio
         const invalida = arr.find(
            (e) =>
               e.inicio &&
               e.fin &&
               e.fin.toString().substring(0, 10) <
                  e.inicio.toString().substring(0, 10)
         )
         if (invalida) {
            this.showSnack(
               'La fecha fin no puede ser menor que la fecha de inicio.',
               'snackError'
            )
            return
         }

         const entradas = arr
            .filter((e) => e.inicio && e.fin)
            .map((e) => ({ fechaInicio: e.inicio, fechaFin: e.fin }))
         const flag =
            tipo === 'SABATINO' ? 'guardandoSabatino' : 'guardandoIntensivo'

         this[flag] = true
         axios
            .put('api/CalendarizacionModulos', { tipo, entradas })
            .then(() => {
               this.showSnack(
                  'Calendarización guardada correctamente.',
                  'snackSuccess'
               )
            })
            .catch((error) => {
               const msg =
                  error.response && typeof error.response.data === 'string'
                     ? error.response.data
                     : 'Error al guardar la calendarización.'
               this.showSnack(msg, 'snackError')
            })
            .finally(() => {
               this[flag] = false
            })
      },
      // --- Programas asignados a cada sección ---
      cargarProgramasAsignados() {
         axios
            .get('api/CalendarizacionModulos/programas')
            .then((r) => {
               this.programasSabatinoIds = r.data.sabatino || []
               this.programasIntensivoIds = r.data.intensivo || []
            })
            .catch(() => {
               this.showSnack(
                  'Error al cargar los programas asignados.',
                  'snackError'
               )
            })
      },
      abrirModalProgramas(tipo) {
         this.tipoModal = tipo
         this.seleccionModal =
            tipo === 'SABATINO'
               ? [...this.programasSabatinoIds]
               : [...this.programasIntensivoIds]
         this.programaAAgregar = null
         this.dialogProgramas = true
      },
      agregarProgramaModal() {
         if (
            this.programaAAgregar &&
            !this.seleccionModal.includes(this.programaAAgregar)
         ) {
            this.seleccionModal.push(this.programaAAgregar)
         }
         this.programaAAgregar = null
      },
      quitarProgramaModal(programaId) {
         this.seleccionModal = this.seleccionModal.filter(
            (id) => id !== programaId
         )
      },
      guardarProgramasModal() {
         this.guardandoProgramas = true
         axios
            .put('api/CalendarizacionModulos/programas', {
               tipo: this.tipoModal,
               programaIds: this.seleccionModal
            })
            .then(() => {
               this.showSnack('Programas guardados correctamente.', 'snackSuccess')
               this.dialogProgramas = false
               // Recargar ambas secciones: la exclusividad puede haber quitado
               // programas de la otra sección.
               this.cargarProgramasAsignados()
            })
            .catch((error) => {
               const msg =
                  error.response && typeof error.response.data === 'string'
                     ? error.response.data
                     : 'Error al guardar los programas.'
               this.showSnack(msg, 'snackError')
            })
            .finally(() => {
               this.guardandoProgramas = false
            })
      },
      // --- Manejo de filas/entradas ---
      agregarEntrada(entradas) {
         entradas.push({ inicio: '', fin: '' })
      },
      eliminarEntrada(entradas, index) {
         entradas.splice(index, 1)
      },
      // --- Motor de automatización ---
      // Evalúa la fecha de hoy contra todas las entradas de la sección:
      //   abierto (dentro del período) > recargo (5 días de gracia) > cerrado.
      calcularEstadoEntradas(entradas) {
         const validas = entradas
            .map((e) => ({
               inicio: this.parseFecha(e.inicio),
               fin: this.parseFecha(e.fin)
            }))
            .filter((e) => e.inicio && e.fin)

         if (!validas.length) {
            return {
               codigo: 'SIN_CONFIG',
               label: 'Sin fechas configuradas',
               color: 'grey',
               icono: 'fas fa-question-circle',
               visible: false,
               aplicaRecargo: false
            }
         }

         const hoy = this.hoySoloFecha()
         let enRecargo = false

         for (const e of validas) {
            // Período normal: entre Fecha de Inicio y Fecha Fin (inclusive)
            if (hoy >= e.inicio && hoy <= e.fin) {
               return {
                  codigo: 'ABIERTO',
                  label: 'Inscripción abierta',
                  color: 'success',
                  icono: 'fas fa-check-circle',
                  visible: true,
                  aplicaRecargo: false
               }
            }
            // Período de recargo: 5 días posteriores a la Fecha Fin
            const finGracia = new Date(e.fin)
            finGracia.setDate(finGracia.getDate() + this.diasGracia)
            if (hoy > e.fin && hoy <= finGracia) {
               enRecargo = true
            }
         }

         if (enRecargo) {
            return {
               codigo: 'RECARGO',
               label: 'Inscripción con Recargo',
               color: 'warning',
               icono: 'fas fa-exclamation-triangle',
               visible: true,
               aplicaRecargo: true
            }
         }

         // Fuera de todo período y de la prórroga -> cerrado
         return {
            codigo: 'CERRADO',
            label: 'Módulos cerrados temporalmente',
            color: 'error',
            icono: 'fas fa-times-circle',
            visible: false,
            aplicaRecargo: false
         }
      },
      // Fecha de hoy sin componente de hora (para comparar solo por día)
      hoySoloFecha() {
         const d = new Date()
         return new Date(d.getFullYear(), d.getMonth(), d.getDate())
      },
      // Convierte "yyyy-MM-dd" a Date local a medianoche
      parseFecha(str) {
         if (!str) return null
         const p = str.toString().substring(0, 10).split('-')
         if (p.length === 3 && p[0].length === 4) {
            return new Date(Number(p[0]), Number(p[1]) - 1, Number(p[2]))
         }
         return null
      },
      // Convierte "HH:mm:ss" -> "HH:mm"
      formatHora(hora) {
         if (!hora) return ''
         return hora.toString().substring(0, 5)
      },
      showSnack(text, color) {
         this.snackText = text
         this.snackColor = color
         this.snackbar = true
      }
   }
}
</script>

<style scoped>
.colorPrimary {
   color: var(--v-primary-base) !important;
}
.seccion-cabecera {
   background: var(--v-primary-base);
   color: #fff;
   font-weight: 700;
   letter-spacing: 1px;
   text-align: center;
   padding: 12px;
   border-radius: 30px;
   font-size: 20px;
   margin-bottom: 16px;
}
.entradas-tabla >>> td,
.entradas-tabla >>> th {
   padding: 4px 8px !important;
}
.seccion-cabecera--btn {
   cursor: pointer;
   transition: filter 0.15s ease, box-shadow 0.15s ease;
}
.seccion-cabecera--btn:hover {
   filter: brightness(1.08);
   box-shadow: 0 2px 8px rgba(0, 0, 0, 0.25);
}
.asignados-lista {
   max-height: 260px;
   overflow-y: auto;
}
</style>
